module.exports = __webpack_public_path__ + "img/143.a79384fd.jpg";